<template>
  <p :class="{ clickable: url !== null }" @click="$emit('openUrl', url)">
    <small>
      <span class="badge" :class="{ 'badge-custom': isCustom }">
        {{ isCustom ? $t('custom_badge_label') : $t('built_in_badge_label') }}
      </span>
    </small>
    {{ name }}
  </p>
</template>

<script>
export default {
  name: 'LoggerLink',
  props: {
    isCustom: { type: Boolean },
    isHovered: { type: Boolean },
    name: { type: String, default: '' },
    isClickable: { type: Boolean },
    url: { type: String, default: null }
  }
}
</script>
